<template>
  <div class="toolbar__group toolbar__select-wrapper">
    <select aria-label="layout" class="toolbar__select" v-model="selected">
      <option value="" disabled selected>Layout</option>
      <option v-for="layout in Object.keys(layouts)" :key="layout" :value="layout">
        {{ layouts[layout] }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'Layout',
  data() {
    return {
      layouts: {
        50: '50% width',
        100: 'Full width',
      },
    };
  },
  computed: {
    selected: {
      get() {
        return this.value || '';
      },
      set(value) {
        this.$emit('layout-change', value);
      },
    },
  },
};
</script>
